import React from 'react';

const MediaFilterContext = React.createContext(null);

export const Provider = MediaFilterContext.Provider;
export const Consumer = MediaFilterContext.Consumer;

export default MediaFilterContext;
